import { render, staticRenderFns } from "./courseregistration.vue?vue&type=template&id=3f09c812&"
import script from "./courseregistration.vue?vue&type=script&lang=js&"
export * from "./courseregistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports